import { ComponentProps } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    className="toaster group"
    expand
    visibleToasts={3}
    gap={12}
    toastOptions={{
      classNames: {
        icon: 'mt-0.5 self-start',
        error:
          'flex items-center p-4 bg-red-50 rounded-xl shadow border-red-200 justify-start items-start gap-3.5 inline-flex text-red-700',
        success:
          'flex items-center p-4 bg-green-25 rounded-xl shadow border-green-100 justify-start items-start gap-3.5 inline-flex text-green-700',
        warning:
          'flex items-center p-4 bg-orange-50 rounded-xl shadow border-orange-200 justify-start items-start gap-3.5 inline-flex text-orange-700',
        info: 'flex items-center p-4 bg-white rounded-xl shadow border border-gray-300 justify-start items-start gap-3.5 inline-flex text-gray-950',
      },
    }}
    {...props}
  />
);

export { Toaster };
